import type { SyntheticEvent } from 'react';

export const addDefaultSource = (ev: SyntheticEvent<HTMLImageElement>): void => {
    const target = ev.target as HTMLImageElement;
    target.src = '/images/Xsite.svg';
    target.style.objectFit = "contain";
    target.style.padding = "20%";
}

export function handleImgLoad(ev: SyntheticEvent<HTMLImageElement>): void {
    const target = ev.target as HTMLImageElement;
    if (!target.src.includes('/images/Xsite.svg')) {
        target.style.cssText = '';
    }
}
